import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { setToken } from "@/lib/auth";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (params.get("expired") === "1") {
      toast.error("Session expired — please sign in again.");
    }
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.token);
      toast.success("Welcome back, gaffer.");
      const next = params.get("next");
      nav(next && next.startsWith("/admin") ? next : "/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="max-w-md mx-auto px-6 py-24">
      <div className="border-2 border-[#332D2B] bg-[#1C1816] p-10">
        <ShieldCheck className="text-[#C8A96A] mx-auto" size={40} />
        <div className="font-mono-retro text-[10px] tracking-[0.4em] text-[#C8A96A] uppercase text-center mt-3">Boardroom Access</div>
        <h1 className="font-display text-4xl text-[#F2EBDD] text-center mt-2">Host Login</h1>
        <form className="mt-7 space-y-4" onSubmit={submit}>
          <div>
            <label className="fz-label">Email</label>
            <input data-testid="login-email" type="email" required className="fz-input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="fz-label">Password</label>
            <input data-testid="login-password" type="password" required className="fz-input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="login-submit" className="btn-primary w-full justify-center mt-2" disabled={loading}>
            {loading ? "Authorising…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
